import { GACodes, LISTING_HEAP_IDS } from '@/src/listings/components/_shared/constants';
import { useBasicInfo } from '@/src/listings/components/_shared/contexts/BasicInfoContext';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { trackAnalyticsEvent } from '@eventbrite/legacy-infra.site-analytics';
import styles from './CreatorBanner.module.scss';

const getEditEventUrl = (id: string, isParentEvent: boolean, isSeries?: boolean, seriesId?: string) => {
  // For series child events, link to the parent event's manage page
  const eventId = isSeries && !isParentEvent && seriesId ? seriesId : id;
  return `/manage/events/${eventId}/details`;
};

export const CreatorBanner = () => {
  const { id, isSeries, isParentEvent, seriesId } = useBasicInfo();

  const editEventUrl = useMemo(
    () => getEditEventUrl(id, isParentEvent, isSeries, seriesId),
    [id, isParentEvent, isSeries, seriesId],
  );

  const handleEditClick = () => {
    trackAnalyticsEvent({
      category: GACodes.GA_CATEGORY_LISTING,
      action: GACodes.GA_ACTION_EDIT_EVENT,
    });
  };

  return (
    <>
      <p className={styles.prompt}>
        <FormattedMessage
          id="Need to make some updates?"
          defaultMessage="Need to make some updates?"
          description="Creator banner prompt text shown to event organizers"
        />
      </p>
      <a
        href={editEventUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleEditClick}
        data-heap-id={LISTING_HEAP_IDS.CREATOR_TOP_BANNER_EDIT}
        className={styles.editLink}
      >
        <FormattedMessage
          id="Edit event"
          defaultMessage="Edit event"
          description="Creator banner link text to edit the event"
        />
      </a>
    </>
  );
};
